import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const history: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M11.516-7.328A5.8 5.8 0 0 1 12-5c0 .813-.164 1.59-.484 2.328A6 6 0 0 1 10.234-.75 5.9 5.9 0 0 1 8.328.516 5.8 5.8 0 0 1 6 1Q4.655.998 3.438.422A5.75 5.75 0 0 1 1.39-1.172a.26.26 0 0 1-.063-.172.26.26 0 0 1 .078-.156L2.47-2.578a.27.27 0 0 1 .203-.078q.123.018.172.094A3.9 3.9 0 0 0 4.25-1.406Q5.075-.998 6-1q.81.001 1.547-.312c.5-.22.926-.504 1.281-.86q.544-.544.86-1.281A3.9 3.9 0 0 0 10-5q0-.809-.312-1.547a3.9 3.9 0 0 0-.86-1.281 3.9 3.9 0 0 0-1.281-.86A4 4 0 0 0 6-9q-.767 0-1.469.281a3.8 3.8 0 0 0-1.25.782L4.36-6.86q.234.235.11.547Q4.329-5.998 4-6H.5a.52.52 0 0 1-.36-.14A.52.52 0 0 1 0-6.5V-10q-.002-.328.313-.469a.47.47 0 0 1 .546.11l1.016 1.015a5.7 5.7 0 0 1 1.906-1.218A5.9 5.9 0 0 1 6-11a5.8 5.8 0 0 1 2.328.484 5.9 5.9 0 0 1 1.906 1.282 5.9 5.9 0 0 1 1.282 1.906M7-7.25v3.5a.26.26 0 0 1-.078.188.23.23 0 0 1-.172.062h-2.5a.28.28 0 0 1-.187-.062A.28.28 0 0 1 4-3.75v-.5q0-.106.063-.172A.26.26 0 0 1 4.25-4.5H6v-2.75q0-.106.063-.172A.26.26 0 0 1 6.25-7.5h.5q.106 0 .172.078.077.066.078.172m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};
